
export default {
  noHeader: false, // 是否出现
  noFooter: false, // 是否出现
}
